import React from 'react'
import styled, { css, keyframes } from 'styled-components'

const width = '48'
const height = '48'
const viewBox = '0 0 48 48'

const refs = []
const fader = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.1;
  }
`

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
  path {
    opacity: 0.125;
    animation: ${fader} 0.8s linear infinite;
  }
  path:nth-child(1) {
    opacity: 0.125;
    animation-delay: 0.1s;
  }
  path:nth-child(2) {
    opacity: 0.25;
    animation-delay: 0.2s;
  }
  path:nth-child(3) {
    opacity: 0.38;
    animation-delay: 0.3s;
  }
  path:nth-child(4) {
    opacity: 0.5;
    animation-delay: 0.4s;
  }
  path:nth-child(5) {
    opacity: 0.63;
    animation-delay: 0.5s;
  }
  path:nth-child(6) {
    opacity: 0.75;
    animation-delay: 0.6s;
  }
  path:nth-child(7) {
    opacity: 0.88;
    animation-delay: 0.7s;
  }
  path:nth-child(8) {
    opacity: 1;
    animation-delay: 0.8s;
  }
`

const defaultProps = {
  children: [
    <g fill="#FFF" fillRule="evenodd" key="key-0">
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M6.40295206,11.8323639 C8.89229918,9.72202612 12.0469744,8.36571455 15.5138558,8.10725811 L15.5138558,0.292166879 C9.8704264,0.571089327 4.74111421,2.80217654 0.80488596,6.31209686 L6.40295206,11.8323639 Z"
        transform="translate(7)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M7.92508383,15.4930781 C8.18718279,12.07467 9.56260934,8.96354449 11.7026888,6.50879305 L6.10462274,0.9888184 C2.54523587,4.87005058 0.283001647,9.92837057 0.000148246021,15.4930781 L7.92508383,15.4930781 Z"
        transform="translate(0 7)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M11.7027481,9.84832084 C9.56237214,7.3935694 8.18724209,4.28273623 7.92514313,0.864035825 L-8.89476141e-05,0.864035825 C0.282764453,6.42903569 2.54529517,11.4870633 6.10468204,15.3685879 L11.7027481,9.84832084 Z"
        transform="translate(0 24)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M15.5137075,4.25020663 C12.0471227,3.99175019 8.89215093,2.63543862 6.40280381,0.525100852 L0.805034207,6.04536788 C4.74096596,9.5552882 9.87057465,11.786083 15.5137075,12.0650055 L15.5137075,4.25020663 Z"
        transform="translate(7 35)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M10.029132,0.525013141 C7.53978489,2.63535091 4.38481315,3.99166248 0.918228286,4.25011892 L0.918228286,12.0652101 C6.56165767,11.7862877 11.6909699,9.55520049 15.6271981,6.04528016 L10.029132,0.525013141 Z"
        transform="translate(24 35)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M4.50697059,0.86418201 C4.24487163,4.28259004 2.86944508,7.39371559 0.729365579,9.84846703 L6.32743168,15.3684417 C9.88681855,11.4872095 12.1490528,6.42888951 12.4319062,0.86418201 L4.50697059,0.86418201 Z"
        transform="translate(35 24)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M0.729306281,6.50893924 C2.86938578,8.96369068 4.24481233,12.0748162 4.50691129,15.4932243 L12.4321434,15.4932243 C12.14929,9.92851676 9.88675925,4.87019676 6.32737238,0.988964586 L0.729306281,6.50893924 Z"
        transform="translate(35 7)"
      />
      <path
        ref={(c) => {
          refs.push(c)
        }}
        d="M0.918346883,0.29225459 L0.918346883,8.10705345 C4.38463526,8.36580226 7.53960699,9.72182146 10.0292506,11.8324516 L15.6270202,6.31218457 C11.6910885,2.80226425 6.56147977,0.571177038 0.918346883,0.29225459"
        transform="translate(24)"
      />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LoadingSpinner'
})
